<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path class="bright" d="M11,8v1c0,0.55-0.45,1-1,1H2c-0.55,0-1-0.45-1-1V8H0v1c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V8H11z" />
</svg>
</template>